import toast from '@/composables/toast';
import getErrorMessage from './errorMessageKr';
import ERROR_SPEC from './errorSpec';
import store from '@/store';
import router from '@/router';

export default {
  //API이외의 에러메세지
  of(spec, subMsg) {
    return toast.errorSub(getErrorMessage(spec), subMsg ?? '');
  },

  //확인 필요
  request(error) {
    return toast.errorSub(ERROR_SPEC.COMMON.REQUEST_FAIL, error.message);
  },

  //API에서 전달한 에러메세지 출력
  response(response) {
    if (response.data?.message) {
      return toast.errorSub(response.data.message);
    }

    const subMsg = `${response?.message}`;

    switch (response.errorCode) {
      case 1: //토큰 만료, 토큰 없음
        store.dispatch('authority/logout');
        router.push('/login');
        toast.error(subMsg);
        break;

      case 2: //권한 없음
        router.back();
        toast.error(subMsg);
        break;

      case 3: //OTP 미인증
        router.push('/login');
        toast.error('OTP 인증이 필요합니다.');
        break;

      default:
        toast.errorSub(
          getErrorMessage(ERROR_SPEC.COMMON.RESPONSE_FAIL),
          `${response?.message}`
        );
    }
    return;
  },

  network(error) {
    // return toast.errorSub(getErrorMessage(ERROR_SPEC.COMMON.REQUEST_FAIL), '네트워크 에러가 발생했습니다. 잠시 후에 다시 시도해주세요');
  },

  timeout() {
    return toast.errorSub('요청 시간이 초과되었습니다.', '잠시 후 다시 시도해주세요.');
  },

  common({ data, errorCode, message = '' }) {
    if (data?.message) {
      return toast.errorSub(data.message);
    }

    const subMsg = `${message}`;

    switch (errorCode) {
      case 1: //토큰 만료, 토큰 없음
        store.dispatch('authority/logout');
        router.push('/login');
        toast.error(subMsg);
        break;

      case 2: //권한 없음
        router.back();
        toast.error(subMsg);
        break;

      case 3: //OTP 미인증
        router.push('/login');
        toast.error('OTP 인증이 필요합니다.');
        break;

      default:
        toast.errorSub(getErrorMessage(ERROR_SPEC.COMMON.RESPONSE_FAIL), `${message}`);
    }
    return;
  },
};
